module.exports = __webpack_public_path__ + "img/static_reward.e7b24214.svg";